<template>
  <div class="upload-progress w-100">
    <b-progress
      :value="percent"
      max="100"
      height="8px"
      variant="primary"
      striped
      :animated="!processing"
    />
    <small class="d-block text-muted mt-50">
      <template v-if="processing">
        <b-spinner small /> Sunucuda işleniyor…
      </template>
      <template v-else-if="progress.total > 0">
        {{ formatMB(progress.loaded) }} / {{ formatMB(progress.total) }} · %{{ percent }}
      </template>
      <template v-else>
        <b-spinner small /> Yükleniyor…
      </template>
    </small>
  </div>
</template>

<script>
import { BProgress, BSpinner } from 'bootstrap-vue'

export default {
  name: 'UploadProgress',
  components: {
    BProgress,
    BSpinner,
  },
  props: {
    progress: {
      type: Object,
      required: true,
    },
  },
  computed: {
    percent() {
      if (!this.progress.total) {
        return 0
      }
      return Math.min(100, Math.floor((this.progress.loaded / this.progress.total) * 100))
    },
    processing() {
      return this.progress.total > 0 && this.progress.loaded >= this.progress.total
    },
  },
  methods: {
    formatMB(bytes) {
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
    },
  },
}
</script>
